var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.63 90.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #019866;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path2681",
    className: "cls-1",
    d: "M0,90.66H85.63V0H0V90.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2683",
    className: "cls-2",
    d: "M62.07,81.7v-22.99h4.03v12.65l6.36-6.84h4.73l-6.51,7.44,7.77,9.74h-4.9l-7.45-9.21v9.21h-4.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2685",
    className: "cls-2",
    d: "M23.15,72.07c-.56-1.08-1.48-1.96-2.62-2.6,.36-.29,.69-.61,.98-.96,1.49-1.53,1.52-4.88,.51-6.61-1.22-2.25-3.4-3.53-7.29-3.68l-7.07,.12v23.35s3.94,0,3.94,0c.02-2.61-.03-5.83,0-8.44v-1.7h4.27c.29,0,.59,.03,.88,.09,.89,.19,1.74,.64,2.3,1.31,.69,.86,1.05,2.69,.45,3.68-.63,1.23-1.98,1.99-3.63,1.98h-4.24l1.05,3.08h3.33c2.86,.15,5.18-1.03,6.65-2.91,1.48-1.6,1.51-4.88,.5-6.71Zm-11.56-10.67h3.14s4.31-.26,4.31,3.02c0,0,.32,3.38-2.82,3.92-.08,0-.28,0-.37,0h-4.27v-6.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2687",
    className: "cls-2",
    d: "M56.33,71.95v9.75h4.01v-10.02c-.11-8.03-8.03-7.31-8.03-7.31-1.01,.08-2.07,.16-3,.84-.39,1.75-.67,3.39-1.04,5.03l-.11,.37v-6.09h-4.02s0,17.19,0,17.19h4.02v-9.75c.06-.52,.2-1.03,.41-1.47,.65-1.29,2.02-2.17,3.47-2.25,0,0,4.29-.38,4.27,3.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2689",
    className: "cls-2",
    d: "M42.56,73.18c.1-4.92-3.95-8.83-8.82-8.83s-8.83,3.95-8.83,8.83,3.95,8.83,8.83,8.83c1.29,0,2.51-.28,3.62-.78,.37-1.69,1.16-5.22,1.16-5.22v3.75s0,.83,0,.83v1.1h4.04v-7.26s0-1.26,0-1.26Zm-8.87,4.91c-2.71,0-4.91-2.2-4.91-4.91s2.2-4.91,4.91-4.91,4.91,2.2,4.91,4.91-2.2,4.91-4.91,4.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2691",
    className: "cls-2",
    d: "M51.59,46.32c-.81,2.78-2.86,6.02-6.22,6.83-1.38,.38-3.41,.77-5.54,.61v-4.41c1.99-.01,4.33-.15,5.79-1.96,1.04-1.21,1.34-2.71,1.64-4.15l.11-.52c.22-.91,.41-1.98,.59-3.35v-.03s.02-.02,.02-.02l.07-.55c.66-5.88,1.35-11.95,7.89-13.3,2.08-.23,3.69-.33,5.41-.3v4.47c-1.87-.09-4.22-.09-5.8,1.37-1.01,.9-1.62,2.14-1.92,3.89l-.75,4.42v.11s-1.28,6.91-1.28,6.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2693",
    className: "cls-2",
    d: "M34.9,25.17c-5.96,0-10.79,4.57-10.79,10.23,0,.12,0,18.2,0,18.2h4.85v-15.55l1.69,6.79c1.31,.53,2.75,.83,4.26,.83,5.96,0,10.79-4.59,10.79-10.25s-4.83-10.25-10.79-10.25Zm0,15.87c-3.27,0-5.92-2.51-5.92-5.62s2.65-5.62,5.92-5.62,5.91,2.52,5.91,5.62-2.65,5.62-5.91,5.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2695",
    className: "cls-2",
    d: "M71.78,25.22v15.55l-1.69-6.79c-1.31-.53-2.75-.83-4.26-.83-5.96,0-10.79,4.59-10.79,10.25s4.83,10.25,10.79,10.25,10.79-4.57,10.79-10.23V25.22h-4.84Zm-5.95,23.8c-3.27,0-5.91-2.52-5.91-5.62s2.65-5.62,5.91-5.62,5.92,2.52,5.92,5.62-2.65,5.62-5.92,5.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2697",
    className: "cls-2",
    d: "M7.39,40.74c1.11-14.92,15.67-27.28,34.85-28.61,11.49-.79,22.27,2.54,30.07,8.45l2.41-4.22c-8.49-5.78-19.89-8.78-31.82-7.55C22.48,10.92,7.51,24.73,7.18,40.74c0,0,.08,.29,.22,0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.545b1cfb332baf6ea3eb4b05e788caab.svg";
export { ForwardRef as ReactComponent };